import React from 'react'
import { Menu } from 'antd'

interface CollapsedTabsProps {
    setActiveTab: any
    setVisible: any
}

const CollapsedTabs: React.FC<CollapsedTabsProps> = ({ setActiveTab, setVisible }) => {
    const handleClick = (input: string) => {
        setActiveTab(input)
        setVisible()
    }

    return(
        <div className='collapsed-tabs'>
            <Menu mode='vertical'>
                <Menu.Item key='1' onClick={() => handleClick('home')}>Home</Menu.Item>
                <Menu.Item key='2' onClick={() => handleClick('how')}>How it Works?</Menu.Item>
                <Menu.Item key='3' onClick={() => handleClick('about')}>About Us</Menu.Item>
            </Menu>
        </div>
    )
}

export default CollapsedTabs